/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { VesselAdvancedIntegrity } from './VesselAdvancedIntegrity';
import {
    VesselAdvancedIntegrityFromJSON,
    VesselAdvancedIntegrityFromJSONTyped,
    VesselAdvancedIntegrityToJSON,
} from './VesselAdvancedIntegrity';
import type { VesselAdvancedRegister } from './VesselAdvancedRegister';
import {
    VesselAdvancedRegisterFromJSON,
    VesselAdvancedRegisterFromJSONTyped,
    VesselAdvancedRegisterToJSON,
} from './VesselAdvancedRegister';
import type { VesselAdvancedVessel } from './VesselAdvancedVessel';
import {
    VesselAdvancedVesselFromJSON,
    VesselAdvancedVesselFromJSONTyped,
    VesselAdvancedVesselToJSON,
} from './VesselAdvancedVessel';
import type { VesselBasicResult } from './VesselBasicResult';
import {
    VesselBasicResultFromJSON,
    VesselBasicResultFromJSONTyped,
    VesselBasicResultToJSON,
} from './VesselBasicResult';
import type { VesselPatternsResult } from './VesselPatternsResult';
import {
    VesselPatternsResultFromJSON,
    VesselPatternsResultFromJSONTyped,
    VesselPatternsResultToJSON,
} from './VesselPatternsResult';
import type { VesselPredictionsResult } from './VesselPredictionsResult';
import {
    VesselPredictionsResultFromJSON,
    VesselPredictionsResultFromJSONTyped,
    VesselPredictionsResultToJSON,
} from './VesselPredictionsResult';

/**
 * 
 * @export
 * @interface VesselResult
 */
export interface VesselResult {
    /**
     * 
     * @type {VesselBasicResult}
     * @memberof VesselResult
     */
    basic?: VesselBasicResult;
    /**
     * 
     * @type {VesselPatternsResult}
     * @memberof VesselResult
     */
    analyticsPatterns?: VesselPatternsResult;
    /**
     * 
     * @type {VesselPredictionsResult}
     * @memberof VesselResult
     */
    analyticsPredictions?: VesselPredictionsResult;
    /**
     * 
     * @type {VesselAdvancedRegister}
     * @memberof VesselResult
     */
    advancedRegister?: VesselAdvancedRegister;
    /**
     * 
     * @type {VesselAdvancedIntegrity}
     * @memberof VesselResult
     */
    advancedIntegrity?: VesselAdvancedIntegrity;
    /**
     * 
     * @type {VesselAdvancedVessel}
     * @memberof VesselResult
     */
    advancedVessel?: VesselAdvancedVessel;
}

/**
 * Check if a given object implements the VesselResult interface.
 */
export function instanceOfVesselResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function VesselResultFromJSON(json: any): VesselResult {
    return VesselResultFromJSONTyped(json, false);
}

export function VesselResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): VesselResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'basic': !exists(json, 'basic') ? undefined : VesselBasicResultFromJSON(json['basic']),
        'analyticsPatterns': !exists(json, 'analytics_patterns') ? undefined : VesselPatternsResultFromJSON(json['analytics_patterns']),
        'analyticsPredictions': !exists(json, 'analytics_predictions') ? undefined : VesselPredictionsResultFromJSON(json['analytics_predictions']),
        'advancedRegister': !exists(json, 'advanced_register') ? undefined : VesselAdvancedRegisterFromJSON(json['advanced_register']),
        'advancedIntegrity': !exists(json, 'advanced_integrity') ? undefined : VesselAdvancedIntegrityFromJSON(json['advanced_integrity']),
        'advancedVessel': !exists(json, 'advanced_vessel') ? undefined : VesselAdvancedVesselFromJSON(json['advanced_vessel']),
    };
}

export function VesselResultToJSON(value?: VesselResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'basic': VesselBasicResultToJSON(value.basic),
        'analytics_patterns': VesselPatternsResultToJSON(value.analyticsPatterns),
        'analytics_predictions': VesselPredictionsResultToJSON(value.analyticsPredictions),
        'advanced_register': VesselAdvancedRegisterToJSON(value.advancedRegister),
        'advanced_integrity': VesselAdvancedIntegrityToJSON(value.advancedIntegrity),
        'advanced_vessel': VesselAdvancedVesselToJSON(value.advancedVessel),
    };
}

